/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserManagementConfigurationDto } from './UserManagementConfigurationDto';
import {
    UserManagementConfigurationDtoFromJSON,
    UserManagementConfigurationDtoFromJSONTyped,
    UserManagementConfigurationDtoToJSON,
    UserManagementConfigurationDtoToJSONTyped,
} from './UserManagementConfigurationDto';

/**
 * 
 * @export
 * @interface UserManagementConfigurationResponse
 */
export interface UserManagementConfigurationResponse {
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof UserManagementConfigurationResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof UserManagementConfigurationResponse
     */
    error?: string;
    /**
     * 
     * @type {UserManagementConfigurationDto}
     * @memberof UserManagementConfigurationResponse
     */
    data?: UserManagementConfigurationDto;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementConfigurationResponse
     */
    configurationType?: string;
}

/**
 * Check if a given object implements the UserManagementConfigurationResponse interface.
 */
export function instanceOfUserManagementConfigurationResponse(value: object): value is UserManagementConfigurationResponse {
    return true;
}

export function UserManagementConfigurationResponseFromJSON(json: any): UserManagementConfigurationResponse {
    return UserManagementConfigurationResponseFromJSONTyped(json, false);
}

export function UserManagementConfigurationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserManagementConfigurationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'data': json['data'] == null ? undefined : UserManagementConfigurationDtoFromJSON(json['data']),
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'configurationType': json['configuration_type'] == null ? undefined : json['configuration_type'],
    };
}

export function UserManagementConfigurationResponseToJSON(json: any): UserManagementConfigurationResponse {
    return UserManagementConfigurationResponseToJSONTyped(json, false);
}

export function UserManagementConfigurationResponseToJSONTyped(value?: UserManagementConfigurationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'error': value['error'],
        'data': UserManagementConfigurationDtoToJSON(value['data']),
        'tenant_id': value['tenantId'],
        'configuration_type': value['configurationType'],
    };
}

